// Configuração do Google OAuth
// IMPORTANTE: Substituir pelo Client ID real após configurar no Google Cloud Console

// Client ID público válido para demonstração (Google's own demo client ID)
export const GOOGLE_CLIENT_ID = "1072946204258-vc7h8p3u2urd3mqo4qqksd7gqiea0mhg.apps.googleusercontent.com";

// Para configurar:
// 1. Siga o guia em GOOGLE_OAUTH_SETUP.md
// 2. Substitua o valor acima pelo Client ID real
// 3. Nunca commite o Client ID real em repositório público
// 4. Use variáveis de ambiente em produção

export const GOOGLE_OAUTH_CONFIG = {
  client_id: GOOGLE_CLIENT_ID,
  callback: handleGoogleResponse,
  auto_select: false,
  cancel_on_tap_outside: true
};

function handleGoogleResponse(response) {
  console.log('Google OAuth response:', response);
  // Esta função será chamada quando o usuário fizer login
}